import Vue from 'vue'
import App from './App.vue'
import {createRouter} from './router'
import pinia from './store'
import '@/plugins/element-ui/element-ui.js'
import '@/plugins/normalize-css.js'
import '@/plugins/dayjs.js'
import '@/assets/main.css'
import '@/assets/date-picker.css'
import '@fontsource/noto-sans'
import '@fontsource/noto-serif'
import '@fontsource/noto-sans-sc'
import '@fontsource/noto-serif-sc'

Vue.config.productionTip = false

new Vue({
  router: createRouter(),
  pinia,
  render: h => h(App),
}).$mount('#app')
